import {Companies, Scenarios, YearlyRankings} from "./models.js";

function Game() {
    // Strings
    const name = null;  // scenario name
    const editName = null;
    const userUid = null;

    // Integer
    const monthCount = 0;
    const year = 0;
    const numberOfWeeklyShows = 2;
    const marketSize = null;

    // Boolean
    const awardsRun = false;
    const monthlySimulationRun = false;
    const competitorsPresent = false;
    const yearlyAttributesResetRan = false;

    // Objects
    const settings = {};

    // Datetime
    const datetimeLastPlayed = null;
    const datetimeLastCloudSave = null;

    // Foreign keys
    const currentCompanyId = null;
    const scenarioId = null;

    return {
        name,
        editName,
        userUid,
        year,
        monthCount,
        numberOfWeeklyShows,
        marketSize,
        awardsRun,
        monthlySimulationRun,
        competitorsPresent,
        yearlyAttributesResetRan,
        settings,
        datetimeLastPlayed,
        datetimeLastCloudSave,
        currentCompanyId,
        scenarioId,
    };
}

function getGameCompanies(game) {
    return Companies.find({'gameId': game.$loki});
}

function addGameCompanies(game, companies) {
    companies.forEach(c => {
        c.gameId = game.$loki
    });
}

function removeGameCompanies(game, companies) {
    companies.forEach(c => {
        c.gameId = null
    });
}

function getGameCurrentCompany(game) {
    return Companies.find({'$loki': game.currentCompanyId})[0];
}

function setGameCurrentCompany(game, company) {
    game.currentCompanyId = company.$loki;
}

function getGameScenario(game) {
    return Scenarios.find({'$loki': game.scenarioId})[0];
}

function addGameYearlyRankings(game, yearlyRankings) {
    yearlyRankings.forEach(c => {
        c.gameId = game.$loki
    });
}

function removeGameYearlyRankings(game, yearlyRankings) {
    yearlyRankings.forEach(c => {
        c.gameId = null
    });
}

function getGameYearlyRankings(game) {
    return YearlyRankings.find({'gameId': game.$loki});
}

export { Game, getGameCompanies, addGameCompanies, removeGameCompanies, getGameCurrentCompany, setGameCurrentCompany,
    getGameScenario, addGameYearlyRankings, removeGameYearlyRankings, getGameYearlyRankings};